export function formatCurrency(
  amount: number,
  currency: string,
  locale?: string,
  opts: Pick<Intl.NumberFormatOptions, 'signDisplay'> = {},
) {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    maximumFractionDigits: currency === 'CZK' ? 0 : undefined,
    ...opts,
  }).format(amount / 100);
}

export function formatDateTime(date: Date | number, locale?: string) {
  return new Intl.DateTimeFormat(locale, {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(date);
}

export function formatDate(date: Date | number, locale?: string) {
  return new Intl.DateTimeFormat(locale, {
    dateStyle: 'medium',
  }).format(date);
}

export function formatTime(date: Date | number, locale?: string) {
  return new Intl.DateTimeFormat(locale, {
    timeStyle: 'short',
  }).format(date);
}

export const formatTimeLeft = (milliseconds: number) => {
  const totalSeconds = Math.floor(Math.abs(milliseconds) / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const padZero = (num: number) => String(num).padStart(2, '0');

  return `${hours > 0 ? `${padZero(hours)}:` : ''}${padZero(minutes)}:${padZero(
    seconds,
  )}`;
};

export function numberFormatter(locale: string, amount: number) {
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 1,
    maximumFractionDigits: 2,
  }).format(amount);
}
